"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OEmbedLoader_1 = require("../../components/OEmbedLoader");
new OEmbedLoader_1.OEmbedLoader('.twitter-embed', 'jsonp', 'https://api.twitter.com/1/statuses/oembed.json?url=');
